<template>
  <div id="app">
		<div v-if="$route.meta.commpage">
			<nav-header></nav-header>
			<router-view></router-view>
			<nav-footer></nav-footer>

			<div class="link-type">
				<div class="phone">
					<img src="../static/app/aside1.png" class="phone-img phone-img1">
					<img src="../static/app/aaside1.png" class="phone-img phone-img2">
					<div class="phone-num">13751007289</div>
				</div>
				<div class="wechat">
					<img src="../static/app/aside5.png" class="phone-img wechat-img1">
					<img src="../static/app/aaside5.png" class="phone-img wechat-img2">
					<div class="wechat-qrcode">
						<img src="../static/images/index/qrcode.png" >
					</div>
				</div>
			</div>
		</div>
		<router-view v-if="!$route.meta.commpage"></router-view>


		<el-backtop :bottom="100">
			<i class="el-icon-caret-top"></i>
		</el-backtop>

  </div>
</template>

<script>
  import NavHeader from './components/header.vue'
  import NavFooter from './components/footer.vue'

  export default {
    name: 'app',
    components:{
      NavHeader,NavFooter
    },
		data() {
			return {
				showLoad: true,
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoad = false;
			}, 1500)
		},
		watch: {//使用watch 监听$router的变化
			$route(to, from) {
				if(to.name != from.name) {
					this.showLoad = true;
					setTimeout(() => {
						this.showLoad = false;
					}, 1500)
				}
			}
		}
  }
</script>

<style>
  html, body{
    margin: 0px;
    font-family: "Be Vietnam", sans-serif;
    font-size: 14px;
    font-weight: normal;
    color: #55545b;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
		position: relative;
  }
  img{
    width: 100%;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .ws{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .white-bg{
    background-color: #fff;
  }
	.iottips{
		width: 90%;
		display: inline-block;
	}
	.el-backtop, .el-backtop:hover{
		background-color: #409EFF;
	}
	.el-backtop i{
		color: #fff;
	}
	.el-image{
		transition: 0.5s;
	}
	.el-image img{
		transition: 0.5s;
	}
	.link-type{
		position: fixed;
		right: 0px;
		top: 30%;
		z-index: 1100;
	}
	.link-type > div{
		width: 60px;
		height: 60px;
		line-height: 60px;
		background-color: #409EFF;
		text-align: center;
    margin: 5px 0px;
    color: #fff;
		cursor: pointer;
		position: relative;
	}
	.phone-img{
		width: 37px;
		height: 37px;
		vertical-align: middle;
	}
	.phone-img1, .wechat-img1{
		display: inline;
	}
	.phone-img2, .wechat-img2{
		display: none;
	}
	.phone-num{
		position: absolute;
		right: -240px;
		top: 0px;
		width: 240px;
		height: 60px;
		line-height: 60px;
		background-color:rgb(160, 207, 255);
		color: #333;
		font-size: 27px;
		transition: 0.7s;
		opacity: 0;
		z-index: -1;
		font-weight: 600;
	}
	.phone:hover .phone-img1{
		display: none;
	}
	.phone:hover .phone-img2{
		display: inline;
		width: 41px;
		height: 41px;
	}
	.phone:hover .phone-num{
		right: 60px;
		opacity: 1;
	}
	.wechat-qrcode{
		position: absolute;
		right: -130px;
		top: -60px;
		width: 130px;
		height: 130px;
		opacity: 0;
		transition: 0.7s;
		z-index: -1;
	}
	.wechat:hover .wechat-img1{
		display: none;
	}
	.wechat:hover .wechat-img2{
		display: inline;
		width: 41px;
		height: 41px;
	}
	.wechat:hover .wechat-qrcode{
		right: 70px;
		opacity: 1;
	}
  .container{
    max-width: 1200px;
  }
  @media screen and (max-width: 992px) {
    .container{
      max-width: 960px;
    }
  }
  @media screen and (max-width: 768px) {
    .container {
      max-width: 720px;
    }
		.pa-content{
			padding: 0px 12px;
		}
  }
  @media screen and (max-width: 576px) {
    .container {
      max-width: 540px;
    }
  }
  .container {
    margin-right: auto;
    margin-left: auto;
  }
  ul, li{
    list-style: none;
    margin:0px;
    padding:0px;
  }
  a{
    text-decoration: none;
    color: #555;
  }
	.el-carousel__button{
		background-color: #000;
	}
	.el-carousel__indicators--outside button{
		background-color: #000;
	}
	.banner-cont .el-carousel__container{
		height: 600px;
	}
	.pro-cont2 .el-carousel__container{
		height: 420px;
	}
	.el-image{
		overflow: unset;
    height: 100%;
	}
	@media screen and (max-width:768px) {
		.banner-cont .el-carousel__container{
			height: 200px;
		}
		.pro-cont1 .el-carousel__container{
			height: 240px;
		}
		.pro-cont2 .el-carousel__container{
			height: 270px;
		}
	}
	#loading{
		background-color: #fff;
		height: 100%;
		width: 100%;
		position: fixed;
		z-index: 999999;
		margin-top: 0px;
		top: 0px;
		left: 0px;
	}
	#loading-center{
		width: 100%;
		height: 100%;
		position: relative;
	}
	#loading-center-absolute {
		position: absolute;
		left: 50%;
		top: 50%;
		height: 20px;
		width: 100px;
		margin-top: -10px;
		margin-left: -50px;

	}
	.object{
		width: 20px;
		height: 20px;
		background-color: #409EFF;
		/* background-color: #5f3afc; */
		-moz-border-radius: 50% 50% 50% 50%;
		-webkit-border-radius: 50% 50% 50% 50%;
		border-radius: 50% 50% 50% 50%;
		margin-right: 20px;
		margin-bottom: 20px;
		position: absolute;
	}


	#object_one{
		-webkit-animation: object 2s linear infinite;
		 animation: object 2s linear infinite;
		 }
	#object_two{
		-webkit-animation: object 2s linear infinite -.4s;
		animation: object 2s linear infinite -.4s;
		 }
	#object_three{
		-webkit-animation: object 2s linear infinite -.8s;
		animation: object 2s linear infinite -.8s;
		}
	#object_four{
		-webkit-animation: object 2s linear infinite -1.2s;
		animation: object 2s linear infinite -1.2s;
		}
	#object_five{
		-webkit-animation: object 2s linear infinite -1.6s;
		animation: object 2s linear infinite -1.6s;
		}


	@-webkit-keyframes object{
	  0% { left: 100px; top:0}
	  80% { left: 0; top:0;}
	  85% { left: 0; top: -20px; width: 20px; height: 20px;}
	  90% { width: 40px; height: 15px; }
	  95% { left: 100px; top: -20px; width: 20px; height: 20px;}
	  100% { left: 100px; top:0; }

	}
	@keyframes object{
	  0% { left: 100px; top:0}
	  80% { left: 0; top:0;}
	  85% { left: 0; top: -20px; width: 20px; height: 20px;}
	  90% { width: 40px; height: 15px; }
	  95% { left: 100px; top: -20px; width: 20px; height: 20px;}
	  100% { left: 100px; top:0; }
	}


	.el-submenu__title .el-submenu__icon-arrow{
		transform: rotateZ(-90deg);
	}
	.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
		transform: rotateZ(270deg);
	}
	.el-submenu.is-opened{
		background: #ecf5ff;
	}
	.a_link{
		padding: 8px 15px;
		background: #409EFF;
		color: #fff;
		margin-top: 10px;
	}
	.small-img .el-image__inner{
		vertical-align: middle;
	}
	.el-tabs__item{
		font-size: 18px;
	}
	.el-tabs__header{
		background-color: #fff;
	}
	.el-tabs__nav-wrap{
		max-width: 1200px;
		margin: 0px auto;
	}
	.el-carousel__mask{
		background-color: unset;
	}
	.el-form-item{
		position: relative;
	}
	.el-form-item__label{
		position: absolute;
		top: 0px;
		left: 8px;
    z-index: 9;
		color: #f00;
	}
	.el-textarea__inner{
		min-height: 120px;
	}
  .el-step__icon{
    background: unset;
  }
  .el-step.is-horizontal .el-step__line{
    left: 35px;
  }
  .el-step__head.is-finish{
    color: #fff;
  }
  .el-step__title.is-finish{
    color: #fff;
  }
  .el-step__head.is-finish{
    border-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue